<template>
    <div class="domain-autocomplete" :style="{ width }">
        <FlexGrid align-items="center">
            <FlexGridItem grow="1" margin="10px">
                <autocomplete
                    empty-hint="Start typing to search for a domain."
                    :focus="focus"
                    :height="height"
                    :is-loading="isLoading"
                    :options="domainList"
                    :placeholder="`${domain ? domain : 'cadence-canary'}`"
                    :search="search"
                    @change="onAutocompleteChange"
                    @search="onAutocompleteSearch"
                />
            </FlexGridItem>
            <FlexGridItem width="32px">
                <span class="navigate-to-domain disabled" v-if="!navigateToDomainUrl" />
                <a
                    class="navigate-to-domain"
                    @click="toDmomainUrl"
                    v-if="navigateToDomainUrl"
                />
                <!-- <a
                    class="navigate-to-domain"
                    :href="navigateToDomainUrl"
                    v-if="navigateToDomainUrl"
                /> -->
            </FlexGridItem>
        </FlexGrid>
    </div>
</template>

<script>

import { Autocomplete } from '@/components';
import FlexGrid from '@/components/flex-grid.vue';
import FlexGridItem from '@/components/flex-grid-item.vue';

export default {
    name: 'domain-autocomplete',
    components: {
        FlexGrid,
        FlexGridItem,
        autocomplete: Autocomplete,
    },
    data() {
        return {
            value: undefined,
        };
    },
    props: {
        domain: {
            type: String,
        },
        domainList: {
            type: Array,
            default: () => [],
        },
        focus: {
            type: Boolean,
        },
        height: {
            type: String,
        },
        isLoading: {
            type: Boolean,
        },
        navigateToDomainUrl: {
            type: String,
        },
        search: {
            type: String,
        },
        width: {
            type: String,
        },
    },
    computed: {
    },
    methods: {
        onAutocompleteChange(option) {
            this.$emit('onChange', option);
        },
        onAutocompleteSearch(search) {
            this.$emit('onSearch', search);
        },
        toDmomainUrl() {
            this.$router.push(this.navigateToDomainUrl)
        },
    },
};
</script>


<style lang="stylus">
@require "../../styles/definitions"
@require "../../styles/base.styl"

.domain-autocomplete {
  width: 100%;

  .navigate-to-domain {
    icon('\ea87');

    &.disabled::before {
      opacity: 0.25;
    }

    &::before {
      background-color: primary-color;
      border-radius: 32px;
      color: white;
      display: inline-block;
      height: 32px;
      line-height: 32px;
      text-align: center;
      width: 32px;
    }
  }
}
</style>
